import {
  createAxiosServiceInstance,
  createAxiosHeaderlessInstance
} from '../api';

export const axios = createAxiosServiceInstance();

// Instance for download file without any headers
export const axiosHeaderless = createAxiosHeaderlessInstance();

// FIN-12644: the five watchlist filters are multi-select, so they travel as REPEATED query params
// (`?watchlistCategory=A&watchlistCategory=B`) rather than a comma-joined string like typologyIds
// and sources. Real watchlist values contain commas -- 4,394 of the 7,041 watchlist keyword values
// on dev-1 do, e.g. "lawsuit,prosecution,criminal" -- so a CSV join would be shredded back into
// fragments server-side and match nothing.
//
// `indexes: null` is what makes axios emit `k=a&k=b` instead of its default `k[]=a&k[]=b`.
export const REPEATED_PARAMS_SERIALIZER = { indexes: null };

// Empty multi-select means "no filter". Drop it rather than sending `watchlistCategory=`.
export const omitEmptyArrayFilters = (params) =>
  Object.keys(params).reduce((acc, key) => {
    const value = params[key];
    if (!(Array.isArray(value) && value.length === 0)) {
      acc[key] = value;
    }
    return acc;
  }, {});
